<template>
    <button
      type="button"
      class="manual-approve-btn"
      :disabled="disabled"
      @click="$emit('click')"
    >
      <span class="manual-approve-btn__icon">
        <v-icon size="18" :style="{color: '#ffffff !important'}" color="#ffffff">mdi-check-decagram</v-icon>
      </span>
      <span class="manual-approve-btn__label">{{ label }}</span>
      <span v-if="showCount && count > 0" class="manual-approve-btn__count">{{ count }}</span>
    </button>
  </template>
  
  <script>
  export default {
    name: 'ManualApproveButton',
    props: {
      count: { type: Number, default: 0 },
      label: { type: String, default: 'Manual Approve' },
      disabled: { type: Boolean, default: false },
      showCount: { type: Boolean, default: true },
    },
  }
  </script>
  
  <style scoped lang="scss">
  .manual-approve-btn {
    display: inline-flex;
    align-items: center;
    gap: 0;
    border: none;
    border-radius: 24px;
    padding: 0;
    background: var(--primary-color, #00BD73);
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    font-family: inherit;
    line-height: 1;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
    overflow: hidden;
    vertical-align: middle;
  }
  
  .manual-approve-btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
  }
  
  .manual-approve-btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
  
  .manual-approve-btn__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    background: rgba(0, 0, 0, 0.12);
  }
  
  .manual-approve-btn__label {
    padding: 0 12px;
    white-space: nowrap;
  }
  
  .manual-approve-btn__count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 26px;
    height: 26px;
    margin-right: 10px;
    padding: 0 8px;
    border-radius: 13px;
    background: rgba(255, 255, 255, 0.25);
    font-size: 13px;
    font-weight: 700;
  }
  </style>
  